import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as providerAdminApi from '../../../api/providerAdminApi';
import { useAuth } from '../../../auth/AuthProvider';
import { DataTable } from '../../../components/ui/DataTable';
import { canAccessProviderAdmin } from './providerAdminAccess';

export function DigitizeBindingsPage() {
  const { session } = useAuth();
  const [items, setItems] = useState([]);
  const [queues, setQueues] = useState({ items: [], message: null });
  const [error, setError] = useState(null);
  const allowed = canAccessProviderAdmin(session);

  const load = useCallback(async () => {
    setError(null);
    try {
      const [bindings, queueList] = await Promise.all([
        providerAdminApi.listDigitizeBindings(),
        providerAdminApi.listDigitizeQueues(),
      ]);
      setItems(Array.isArray(bindings) ? bindings : []);
      setQueues(queueList || { items: [], message: null });
    } catch (err) {
      setError(err.message || 'Failed to load Digitize bindings');
      setItems([]);
    }
  }, []);

  useEffect(() => {
    if (allowed) load();
  }, [allowed, load]);

  if (!allowed) {
    return <p className="text-sm text-eorig-muted">Provider Admin access is required.</p>;
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-eorig-muted">
        Stage 3 — bind an existing Originator to a VA queue. Catalog admin stays in VA.
      </p>
      <Link to="/provider/admin/organizations" className="text-sm text-[#003A70]">
        Open Organizations to bind a specific org
      </Link>
      {queues.message ? <p className="text-sm text-eorig-muted">{queues.message}</p> : null}
      {error ? <p className="text-sm text-red-600">{error}</p> : null}
      <DataTable
        columns={[
          { key: 'organization_id', header: 'Organization' },
          { key: 'abdp_e_id', header: 'e_id' },
          { key: 'default_q_id', header: 'q_id' },
          { key: 'status', header: 'Status' },
        ]}
        rows={items}
        rowKey={(row) => row.organization_id}
        emptyMessage="No Digitize bindings yet."
      />
    </div>
  );
}
